export default "__VITE_ASSET__DkgAeluj__"